import React from 'react';
import PropTypes from 'prop-types';
import CogImage from '@learningblocks/exp-constants/lib/Images/mc_settings_icon.svg';
import {Image} from '@learningblocks/storybook-components';

import './style.scss';

/**
 * Hover:
 *   Component to render tooltip on hover state
 */

export function Hover(props) {
  return (
    <div className='ps_tooltip_hover' onClick={props.onClick}>
        <Image
          className='ps_tooltip_hover_icon'
          src={CogImage}
          alt='power supply tooltip settings'
        />
    </div>
  );
}

Hover.propTypes = {
  /**
   * callback function to trigger on click
   */
  onClick: PropTypes.func,
};
